import {
  EventNotificationSettingsDocument,
  useEventNotificationSettingsQuery,
  useUpdateEventNotificationSettingsMutation,
} from '@/dealers/_gen/gql'

import useMsgs from '@/gf/hooks/useMsgs'

import EventNotificationSettingsTable, {
  EventNotificationSetting,
} from '@/gf/components/EventNotificationSettingsTable'

const EventNotificationSettings = ({
  storeId,
  userId,
  notify,
}: {
  storeId: string
  userId: string
  notify: boolean
}) => {
  const [_, msgr] = useMsgs()

  const { data } = useEventNotificationSettingsQuery({ variables: { storeId, userId } })

  const [update] = useUpdateEventNotificationSettingsMutation({
    refetchQueries: [EventNotificationSettingsDocument],
    awaitRefetchQueries: true,
  })

  const settings = data?.store?.users[0]?.notificationSettings
  if (!settings) return null

  const save = (setting: EventNotificationSetting) =>
    update({ variables: { notificationSettings: [setting] } })
      .then(() => msgr.add('Notification settings saved.', 'positive'))
      .catch(() => msgr.addUnknownError())

  return <EventNotificationSettingsTable settings={settings} notify={notify} save={save} />
}

export default EventNotificationSettings
